import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { EventService, TranslationService } from '@spartacus/core'
import { AnalyticsEvent } from '../../analytics/events/analytics.event'
import { MbConstants } from '../mb-constants'

@Injectable({
  providedIn: 'root'
})
export class MbProductService {

  constructor (private translationService: TranslationService,
               private eventService: EventService) {
  }

  addDataSheetUserManualLink (linkText: string, type: string, isCartPage: boolean): Observable<string> {
    return this.translationService.translate(type).pipe(
      map((typeText: string) => {
        const cartIconUrl = isCartPage ? '<img src= "/../../assets/icons/svg/data-sheet.svg" ' +
          'class="mr-1 mb-1 mb-cart-item-icons"\n' +
          'alt="Download sheet icon"\n' +
          'title="Data Sheet Icon"\n' +
          'aria-label="Data Sheet"\n' +
          'data-cy="mb-cart-data-sheet-icon">' : ''
        if (linkText?.match(/<a href="([^><]+)" download="([^<>]+)">([^]+)<\/a>/g)) {
          return linkText?.substr(0, linkText?.indexOf('>') + 1)?.concat(cartIconUrl).concat(typeText)?.concat('</a>')
        }
        return ''
      })
    )
  }

  sendGTMEvent (product: any) {
    this.eventService.dispatch(
      new AnalyticsEvent(MbConstants.PRODUCT_SKU, 'Copy Order Number', `${product.name?.replace(/<[^>]*>/g, '')} - ${product.code}`,
        `${product.code}`))
  }
}
